var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template" },
    [
      !_vm.selectedTemplate
        ? _c("div", { staticClass: "no template-card" }, [
            _c("span", [_vm._v("Please select a template")])
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedTemplate
        ? _c(
            "div",
            { staticClass: "template-info-container" },
            [
              _c("object-main-info", {
                attrs: {
                  fields: _vm.fields,
                  identifier: _vm.template.name ? _vm.template.name : "",
                  "identifier-label": _vm.$tc("Label", 1),
                  "editing-data": _vm.editingData,
                  "show-edit-button":
                    _vm.actionToExecute !== "addTemplate" &&
                    _vm.userHasPermission("user_update"),
                  "card-label": _vm.cardLabel,
                  height: _vm.editingData ? "33%" : "18%",
                  "submit-button-label": _vm.submitButtonLabel,
                  "required-fields-filled": _vm.requiredFieldsAreFilled
                },
                on: {
                  "toggle-edit": _vm.toggleEdit,
                  "update-object": _vm.updateTemplate,
                  "save-object": _vm.saveObject,
                  "cancel-edit": function($event) {
                    _vm.discardChangesDialogIsOpen = true
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "buttons-before-edit-slot",
                      fn: function() {
                        return [
                          _vm.actionToExecute !== "addTemplate"
                            ? _c("custom-button", {
                                attrs: {
                                  icon: "delete",
                                  "icon-size": 13,
                                  height: "20px",
                                  width: "20px",
                                  "button-styling": _vm.buttonStyling
                                },
                                on: {
                                  buttonClick: function($event) {
                                    _vm.deleteDialogIsOpen = true
                                  }
                                }
                              })
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  273665885
                )
              }),
              _vm._v(" "),
              _c("import-specific-info", {
                key: _vm.updateSpecificInfoKey,
                attrs: {
                  fields: _vm.template.fields,
                  valueOptions: _vm.templatesByTypeOptions,
                  "editing-data": _vm.editingData,
                  "required-fields-filled": _vm.requiredFieldsAreFilled,
                  "submit-button-label": _vm.submitButtonLabel,
                  layerSelected: _vm.template.layer
                },
                on: {
                  "cancel-edit": function($event) {
                    _vm.discardChangesDialogIsOpen = true
                  },
                  "save-template": function($event) {
                    _vm.saveChangesDialogIsOpen = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        staticStyle: { position: "absolute" },
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.saveChangesDialogIsOpen,
          title: _vm.$t("SaveChanges"),
          content: _vm.$t("SaveChangesContent"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-content-save",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.saveObject,
          secondaryAction: function($event) {
            _vm.saveChangesDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.discardChangesDialogIsOpen,
          title: _vm.$t("DiscardChanges"),
          content: _vm.$t("ClusterCreationConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.cancelEdit,
          secondaryAction: function($event) {
            _vm.discardChangesDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.deleteDialogIsOpen,
          title: _vm.$t("DeleteTemplate"),
          content: _vm.$t("TemplateDeletionConfirmation"),
          mainActionLabel: _vm.$t("Delete"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.deleteTemplate,
          secondaryAction: function($event) {
            _vm.deleteDialogIsOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7794478", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7794478","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/WorkspaceManagement/Templates/Import.vue
// module id = null
// module chunks = 